import React from 'react';
import styles from './icons.module.scss';

const EngineeringUsage = () => (
  <>
    <h2>Engineering Usage</h2>
    <ol>
      <li>
        CSS variable: <code className={styles.code}>content: $rm-hand-holding-heart;</code>
      </li>
      <li>
        Class name: <code className={styles.code}>class=&quot;rm rm-hand-holding-heart&quot;</code>
      </li>
      <li>
        React: <code className={styles.code}>{'<Icon iconType="hand-holding-heart" />'}</code>
      </li>
    </ol>
  </>
);

export default EngineeringUsage;
